package fyi.moko.hotpl.domain.usecase

import fyi.moko.hotpl.data.backup.LocalBackupManager

class ExportBackupUseCase(
    private val backupManager: LocalBackupManager,
) {
    suspend operator fun invoke(): String = backupManager.exportJson()
}